// extracted by mini-css-extract-plugin
module.exports = {"Technology":"technology-module--Technology--3UnxR"};